function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 78.5,
  cy: 78.5,
  r: 78.5,
  fill: "#F7F7F7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M120 27.5343C120 22.5247 116.293 18.2881 111.328 17.6228L107.613 17.125C107.089 17.0548 106.601 17.4047 106.499 17.9236L84.9534 127.743C84.8322 128.36 85.3052 128.935 85.9347 128.935H94.253C94.6183 128.935 94.9546 128.736 95.1301 128.416L116.311 89.7524C118.731 85.3339 120 80.3769 120 75.3388V27.5343Z",
  fill: "#818181"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M117.809 27C117.809 21.4772 113.331 17 107.809 17H50C44.4772 17 40 21.4771 40 27V74.0954C40 79.1755 41.29 84.1723 43.7491 88.6175L64.3495 125.856C64.7017 126.492 65.3719 126.887 66.0995 126.887H91.709C92.4366 126.887 93.1068 126.492 93.459 125.856L114.059 88.6175C116.518 84.1723 117.809 79.1755 117.809 74.0954V27Z",
  fill: "#C4C4C4"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 49,
  y: 33,
  width: 60,
  height: 45,
  rx: 2,
  fill: "#6D6D6D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M64.571 126.205H93.4509L93.719 127.766C93.824 128.377 93.3534 128.935 92.7334 128.935H66.5877C66.2133 128.935 65.8702 128.726 65.6987 128.393L64.571 126.205Z",
  fill: "#6D6D6D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M64.4957 126.205C63.3318 116.135 69.1216 106.692 78.7501 103.523C81.6274 102.576 84.9595 101.495 88.8009 100.269C108.936 93.8428 114.805 87.3007 114.805 87.3007L93.384 126.205H64.4957Z",
  fill: "#AAAAAA"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M76.8047 23.3341C76.8224 22.9353 76.8163 22.5596 76.8595 22.1893C77.0042 20.9607 78.0626 20.1192 79.3393 20.1995C80.4799 20.2712 81.4131 21.2786 81.4258 22.4538C81.4289 22.745 81.4264 23.0362 81.4264 23.3208C81.6745 23.3882 81.8994 23.4217 82.0964 23.5141C82.1973 23.5615 82.311 23.7147 82.3122 23.8211C82.3262 25.2285 82.3195 26.6366 82.3238 28.0446C82.3244 28.2379 82.2411 28.3394 82.0654 28.4015C81.1407 28.7291 80.219 29.0666 79.2925 29.3894C79.1892 29.4253 79.0512 29.4216 78.9472 29.3851C78.0505 29.0708 77.1598 28.7364 76.2618 28.4264C76.0211 28.3431 75.9348 28.2227 75.9372 27.9655C75.9487 26.6183 75.9506 25.2711 75.9354 23.9245C75.9323 23.646 76.0314 23.5129 76.2886 23.46C76.4558 23.4259 76.6199 23.3797 76.8047 23.3341ZM81.0501 25.9794C81.0501 25.5751 81.044 25.1702 81.0525 24.7659C81.0562 24.5853 81.0027 24.4795 80.8112 24.4522C79.6932 24.2953 78.5757 24.2904 77.4571 24.4467C77.2674 24.4734 77.2084 24.5689 77.2103 24.7525C77.2163 25.5617 77.2163 26.3703 77.209 27.1795C77.2072 27.346 77.2595 27.4342 77.4218 27.4895C77.938 27.6652 78.4475 27.8604 78.9636 28.0355C79.0597 28.0683 79.1855 28.0713 79.281 28.0385C79.8068 27.8598 80.326 27.6616 80.8507 27.4804C81.0161 27.4233 81.0568 27.3248 81.0525 27.1618C81.0434 26.7685 81.0501 26.3739 81.0501 25.9794ZM77.9137 23.2034C78.7447 23.2034 79.5193 23.2034 80.3455 23.2034C80.3218 22.8277 80.3364 22.4605 80.2683 22.1103C80.1649 21.5826 79.7345 21.2975 79.1405 21.2956C78.5374 21.2944 78.1015 21.5692 77.9963 22.0896C77.9222 22.4496 77.938 22.8271 77.9137 23.2034Z",
  fill: "#AAAAAA"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M80 129.5C80 129.5 80.5 154.5 64.5 153.5",
  stroke: "#4C4C4C",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgTrezorDevice = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrezorDevice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trezor-device.c34e1d40.svg";
export { ForwardRef as ReactComponent };